import BooleanFilter from "@search/store/filters/primitive/BooleanFilter";

class OnlineExclusiveFilter extends BooleanFilter {
  constructor(value: boolean) {
    super({
      defaultValue: false,
      label: "Online Exclusive",
      name: "onlineExclusive",
      value,
    });
  }
}

export default OnlineExclusiveFilter;
export { OnlineExclusiveFilter };
